import { render, staticRenderFns } from "./shebei.vue?vue&type=template&id=0c25ac62&scoped=true&"
import script from "./shebei.vue?vue&type=script&lang=js&"
export * from "./shebei.vue?vue&type=script&lang=js&"
import style0 from "./shebei.vue?vue&type=style&index=0&id=0c25ac62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25ac62",
  null
  
)

export default component.exports